// PAST21 theme JS
document.addEventListener('DOMContentLoaded', function(){
  var menuBtn = document.getElementById('menuBtn');
  var dropdown = document.getElementById('dropdown');
  if (menuBtn && dropdown) {
    menuBtn.addEventListener('click', function(e){
      e.stopPropagation();
      dropdown.classList.toggle('open');
    });
    document.addEventListener('click', function(e){
      if (!dropdown.contains(e.target) && e.target !== menuBtn){
        dropdown.classList.remove('open');
      }
    });
  }

  // overlay click-to-close
  document.querySelectorAll('.overlay').forEach(function(overlay){
    overlay.addEventListener('click', function(e){
      if (e.target === overlay){ overlay.classList.remove('open'); }
    });
  });

});

// product page helpers
function selectVariant(btn){
  document.querySelectorAll('.size-btn').forEach(function(b){ b.classList.remove('selected'); });
  btn.classList.add('selected');
  var sel = document.getElementById('variant-select');
  if (sel) sel.value = btn.getAttribute('data-variant-id');
}
function selectSize(btn){
  // legacy alias
  selectVariant(btn);
}
function openSizeGuide(){
  var m = document.getElementById('sizeGuideModal');
  if (m) m.classList.add('open');
}
function notifySize(size){
  var label = document.getElementById('notifySizeLabel');
  if (label) label.textContent = size;
  var m = document.getElementById('notifyModal');
  if (m) m.classList.add('open');
}
function closeModal(id){
  var m = document.getElementById(id);
  if (m) m.classList.remove('open');
}
function submitNotify(e){
  e.preventDefault();
  closeModal('notifyModal');
  alert('Thanks — we will notify you when this size is back.');
}

// product image gallery
(function(){
  var mainImg = document.getElementById('pgMainImg');
  var thumbs = document.querySelectorAll('.pg-thumb');
  if(!mainImg || !thumbs.length) return;
  thumbs.forEach(function(btn){
    btn.addEventListener('click', function(){
      mainImg.src = btn.getAttribute('data-src');
      mainImg.alt = btn.getAttribute('data-alt') || '';
      thumbs.forEach(function(b){ b.classList.remove('active'); });
      btn.classList.add('active');
    });
  });
})();

// social proof popups — "someone just bought this"
(function(){
  var popup = document.getElementById('proofPopup');
  if(!popup) return;
  var _names = ["Jayden","Maya","Marcus","Riley","Sofia","Darius","Elena","Tyrell","Naomi","Chris","Aaliyah","Dezmond","Zoe","Malik","Jasmine","Terrence","Kiara","Darnell","Alexis","Jalen","Brianna","Kobe","Talia","Deshawn","Nia","Andre","Keisha","Jamal","Tiana","Corey","Diamond","Trayvon","Essence","Dominique","Kayla","Brandon","Imani","Caleb","Sierra","Dante","Monica","Elijah","Tasha","Quincy","Renee","Isaiah","Bianca","Xavier","Tanya","Devon","Keenan","Latrice","Marquis","Shanice","Dre","Alicia","Tevin","Camila","Joshua","Priya","Denzel","Nadia","Kameron","Yasmin","Tariq","Gabrielle","Malcolm","Denise","Khalil","Vanessa","Omari","Tatyana","Jermaine","Lucia","Dion","Rosa","Kelvin","Marta","Antoine","Paula","Cedric","Rena","Byron","Tessa","Reggie","Alina","Clifton","Noor","Samson","Delia","Tristan","Aisha","Emmett","Lena","Hugo","Cleo","Ramon","Iris","Silas","June"];
  var _cities = ["Los Angeles, CA","New York, NY","Chicago, IL","Houston, TX","Atlanta, GA","Miami, FL","Dallas, TX","Phoenix, AZ","Brooklyn, NY","Oakland, CA","Detroit, MI","Philadelphia, PA","Charlotte, NC","Las Vegas, NV","Seattle, WA","Denver, CO","Baltimore, MD","Memphis, TN","New Orleans, LA","Cleveland, OH","Newark, NJ","St. Louis, MO","Tampa, FL","Orlando, FL","San Diego, CA","Sacramento, CA","Fresno, CA","Compton, CA","Inglewood, CA","Long Beach, CA","Bronx, NY","Queens, NY","Harlem, NY","Jersey City, NJ","Boston, MA","Washington, DC","Richmond, VA","Raleigh, NC","Durham, NC","Columbia, SC","Jacksonville, FL","Fort Lauderdale, FL","Birmingham, AL","Nashville, TN","Louisville, KY","Cincinnati, OH","Columbus, OH","Indianapolis, IN","Milwaukee, WI","Minneapolis, MN","Kansas City, MO","Oklahoma City, OK","Albuquerque, NM","El Paso, TX","San Antonio, TX","Austin, TX","Fort Worth, TX","Salt Lake City, UT","Portland, OR","San Francisco, CA","San Jose, CA","Stockton, CA","Bakersfield, CA","Riverside, CA","Anaheim, CA","Honolulu, HI","Omaha, NE","Des Moines, IA","Wichita, KS","Baton Rouge, LA","Shreveport, LA","Mobile, AL","Huntsville, AL","Chattanooga, TN","Knoxville, TN","Lexington, KY","Akron, OH","Toledo, OH","Dayton, OH","Grand Rapids, MI","Flint, MI","Gary, IN","Fort Wayne, IN","Madison, WI","St. Paul, MN","Lincoln, NE","Topeka, KS","Colorado Springs, CO","Aurora, CO","Mesa, AZ","Tucson, AZ","Henderson, NV","Reno, NV","Spokane, WA","Tacoma, WA","Providence, RI","Hartford, CT","Norfolk, VA","Greensboro, NC","Charleston, SC"];
  var buyers = _names.map(function(n, i){ return { name: n, city: _cities[i] }; });
  var products = [];
  var titleEl = document.getElementById('proofTitle');
  var subEl = document.getElementById('proofSub');
  var imgEl = document.getElementById('proofImg');
  var linkEl = document.getElementById('proofLink');
  var hideTimer = null;

  function pick(a){ return a[Math.floor(Math.random() * a.length)]; }

  function hide(){
    popup.classList.remove('show');
    popup.setAttribute('aria-hidden', 'true');
  }

  function show(){
    if(!products.length) return;
    var b = pick(buyers);
    var prod = pick(products);
    titleEl.textContent = b.name + ' from ' + b.city;
    subEl.textContent = 'just copped the ' + prod.title;
    if(linkEl && prod.url) linkEl.href = prod.url;
    if(prod.image){ imgEl.src = prod.image; imgEl.style.display = 'block'; }
    else { imgEl.style.display = 'none'; }
    popup.classList.add('show');
    popup.setAttribute('aria-hidden', 'false');
    if(hideTimer) clearTimeout(hideTimer);
    hideTimer = setTimeout(hide, 5000);
  }

  document.getElementById('proofClose').addEventListener('click', hide);

  // pull the live product catalog so current + future launches are picked automatically
  fetch('/products.json?limit=250')
    .then(function(r){ return r.json(); })
    .then(function(d){
      products = (d.products || []).map(function(p){
        return {
          title: p.title,
          url: '/products/' + p.handle,
          image: (p.images && p.images[0] && p.images[0].src) || ''
        };
      });
      if(products.length){
        setTimeout(show, 4000);      // first popup shortly after load
        setInterval(show, 10000);    // then every 10 seconds
      }
    })
    .catch(function(){});
})();

// hide fallback IG tiles once a feed app renders real posts
(function(){
  var feed = document.getElementById('instagram-feed');
  if(!feed) return;
  function check(){
    if(feed.querySelector('img')){
      feed.querySelectorAll('.ugc-fallback').forEach(function(el){ el.remove(); });
    }
  }
  check();
  new MutationObserver(check).observe(feed, { childList: true, subtree: true });
})();

// Instagram auto-feed via Instafeed Feed API (updates whenever you post)
(function(){
  var feed = document.getElementById('instagram-feed');
  if(!feed) return;
  var API_KEY = 'ifk_7e9c5be92a97266e68dd6090cb5c8e6cd8f67d82843ad9a9';
  var CACHE_KEY = 'past21_ig_feed';
  var CACHE_TTL = 60 * 60 * 1000; // 1 hour

  // Per Mintt's Feed API docs, account + fid + fu are required query params.
  // v6 = Instagram connected via "Instagram Login"; v5 = "Meta for Business".
  function endpoint(){
    var acct = (window.PAST21_SHOP_DOMAIN || '').trim();
    return 'https://instafeed.nfcube.com/feed/v6?limit=8'
      + '&account=' + encodeURIComponent(acct)
      + '&fu=0&fid=0';
  }
  function pickImage(post){
    if(post.images && post.images.standard_resolution && post.images.standard_resolution.url)
      return post.images.standard_resolution.url;
    return post.media_url || post.image_url || post.image || post.thumbnail_url || post.thumbnail || '';
  }
  function pickLink(post){
    return post.permalink || post.link || post.url || 'https://instagram.com/wearpast21';
  }
  function pickCaption(post){
    if(post.caption && typeof post.caption === 'object') return post.caption.text || '';
    return post.caption || '';
  }
  function pickPosts(data){
    if(!data || !data.meta || data.meta.code !== 200) return [];
    if(Array.isArray(data.data)) return data.data;
    return [];
  }

  function render(posts){
    posts = posts.filter(function(p){ return pickImage(p); }).slice(0, 8);
    if(!posts.length) return false;
    feed.innerHTML = '';
    posts.forEach(function(post){
      var a = document.createElement('a');
      a.className = 'ugc-tile ig-post';
      a.href = pickLink(post);
      a.target = '_blank';
      a.rel = 'noopener';
      var img = document.createElement('img');
      img.src = pickImage(post);
      img.alt = (pickCaption(post) || 'Instagram post @wearpast21').slice(0, 120);
      img.loading = 'lazy';
      a.appendChild(img);
      feed.appendChild(a);
    });
    return true;
  }

  // use cached feed when fresh, so we don't hammer the API on every page view
  try {
    var cached = JSON.parse(localStorage.getItem(CACHE_KEY) || 'null');
    if(cached && (Date.now() - cached.at < CACHE_TTL) && cached.posts && cached.posts.length){
      if(render(cached.posts)) return;
    }
  } catch(e){}

  fetch(endpoint(), { headers: { 'X-API-Key': API_KEY } })
    .then(function(r){ return r.json(); })
    .then(function(data){
      var posts = pickPosts(data);
      if(!posts.length) return; // keep fallback tiles
      try { localStorage.setItem(CACHE_KEY, JSON.stringify({ at: Date.now(), posts: posts })); } catch(e){}
      render(posts);
    })
    .catch(function(){ /* keep fallback tiles on any error */ });
})();

// ---------- announcement bar ----------
(function(){
  var bar = document.getElementById('announceBar');
  if(!bar) return;
  try { if(sessionStorage.getItem('past21_announce') === 'hide'){ bar.remove(); return; } } catch(e){}
  document.getElementById('announceClose').addEventListener('click', function(){
    try { sessionStorage.setItem('past21_announce', 'hide'); } catch(e){}
    bar.remove();
  });
})();

// ---------- quick add (complete the fit) ----------
(function(){
  var btns = document.querySelectorAll('.quick-add-btn[data-variant-id]');
  if(!btns.length) return;
  btns.forEach(function(btn){
    btn.addEventListener('click', function(){
      var id = btn.getAttribute('data-variant-id');
      btn.disabled = true;
      var original = btn.textContent;
      btn.textContent = 'Adding...';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: id, quantity: 1 })
      }).then(function(r){ if(!r.ok) throw 0; return r.json(); })
        .then(function(){
          btn.textContent = 'Added to cart';
          return fetch('/cart.js').then(function(r){ return r.json(); });
        })
        .then(function(cart){
          var link = document.querySelector('.cart-icon');
          if(link) link.textContent = 'Cart (' + cart.item_count + ')';
          setTimeout(function(){ btn.disabled = false; btn.textContent = original; }, 2200);
        })
        .catch(function(){
          btn.disabled = false; btn.textContent = original;
        });
    });
  });
})();

// ---------- product description read-more (auto-trims long descriptions) ----------
(function(){
  var desc = document.querySelector('.pdesc-legacy');

/* PAST21: Auto description accordions */
(function(){function b(){document.querySelectorAll(".pdesc-raw").forEach(function(r){if(r.dataset.d)return;r.dataset.d=1;var t=document.createElement("div");t.innerHTML=r.innerHTML;var s="";var p=t.querySelector("p");if(p&&p.textContent.trim()){s='<div class="pdesc-short">'+p.outerHTML+"</div>";p.remove()}var a=[];var h=t.querySelectorAll("h1,h2,h3,h4,h5,h6");if(h.length){h.forEach(function(x){var ti=x.textContent.trim();var pt=[];var n=x.nextSibling;while(n&&!(n.nodeType===1&&/^H[1-6]$/.test(n.tagName))){if(n.nodeType===1){var ps=n.tagName==="P"?[n]:[].slice.call(n.querySelectorAll("p"));ps.forEach(function(q){var v=q.textContent.trim().replace(/^[-\u2013\u2014]\s*/,"");if(v)pt.push("<li>"+v+"</li>")});if(!ps.length&&n.outerHTML)pt.push(n.outerHTML)}n=n.nextSibling}if(ti&&pt.length)a.push({t:ti,b:"<ul>"+pt.join("")+"</ul>"});x.remove()})}else{t.querySelectorAll("li").forEach(function(x){var st=x.querySelector("strong");if(st){var lb=st.textContent.trim().replace(/:$/,"");st.remove();var vl=x.textContent.trim().replace(/^[:\s\u2013\u2014-]+/,"");if(lb&&vl)a.push({t:lb,b:"<p>"+vl+"</p>"})}});var u=t.querySelector("ul");if(u)u.remove();t.querySelectorAll("p").forEach(function(x){var v=x.textContent.trim();if(/ship|deliver|made.to.order|arrive/i.test(v)&&v){a.push({t:"Shipping",b:"<p>"+v+"</p>"});x.remove()}})}var re=t.innerHTML.trim();if(re)a.push({t:"Details",b:re});var o='<div class="pdesc">'+s;a.forEach(function(x){o+='<details class="pdesc-item"><summary><span>'+x.t+'</span></summary><div class="pdesc-body">'+x.b+"</div></details>"});r.innerHTML=o+"</div>"})}if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",b);else b})();
  if(!desc) return;
  // only add the toggle when the description actually overflows
  if(desc.scrollHeight <= desc.clientHeight + 4) return;
  var btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'desc-toggle';
// cache-bust 1
  btn.textContent = 'Read more';
  btn.addEventListener('click', function(){
    var open = desc.classList.toggle('expanded');
    btn.textContent = open ? 'Show less' : 'Read more';
  });
  desc.parentNode.insertBefore(btn, desc.nextSibling);
})();

